import $ from './jquery.js';
import Vue from './vue.min.js';
        
var config= {
    url: window.location.origin + '/wp-admin/admin-ajax.php',
    itemsPerPage: 10
};

if( document.getElementById('post-type') !== null ) {
    var app = new Vue({
        el : '#advanced-search',
        data : {
            postType: '',
            taxonomy: '',
            searchTerm: '',
            mainCat: '',
            subCat: '',
            categories: [],
            subCategories: [],
            products: [],
            isLoading: false,
            currentPageIndex: 0,
            itemsPerPage: config.itemsPerPage,
            debounceTimeout: null
        },
        created : function() {
            this.postType = String(document.getElementById('post-type').value);
            this.taxonomy = String(document.getElementById('taxonomy').value);
            console.log('created()');
            var data = {
                    action: 'search_action', 
                    postType: this.postType,
                    taxonomy: this.taxonomy,
                    searchType: 'mainCat'
                };
            
            this.ajax(data, this.fetchCategoriesCallback);
        },
        computed: {
            totalPages: function() {
                return Math.ceil(this.products.length / this.itemsPerPage);
            }
        },
        filters : {
            replaceAmp: function(value) {
                return value.replace('&amp;', '&');
            }
        },
        methods : {
            ajax : function(data, success) {
                var _this = this;
                $.ajax({
                    type: 'POST', 
                    url: config.url, 
                    data: data,
                    success: success,
                    error: function(err) {
                        console.log(err);
                        _this.isLoading = false;
                    },
                    dataType: 'json'
                });
                console.log(data);
                return;
            },
            fetchSubCategories: function() {
                console.log('fetchSubCategories()');
                
                if(typeof this.mainCat == "number") {
                    var data = {
                        action: 'search_action', 
                        postType: this.postType,
                        taxonomy: this.taxonomy,
                        searchType: 'subCat',
                        parentID: this.mainCat
                    };
                    this.ajax(data, this.fetchSubCategoriesCallback);
                }
                this.fetchProducts();
                return;
            },
            fetchProducts: function() {
                console.log('fetching products');
                var data = null;
                this.isLoading = true;
                if(typeof this.subCat == "number") {
                    data = {
                        action: 'search_action', 
                        postType: this.postType, 
                        taxonomy: this.taxonomy,
                        searchTerm: this.searchTerm,
                        searchType: 'product',
                        parentID: this.subCat
                    };
                } else if ( typeof this.mainCat == "number") {
                    data = {
                        action: 'search_action', 
                        postType: this.postType,
                        taxonomy: this.taxonomy,
                        searchTerm: this.searchTerm,
                        searchType: 'product',
                        parentID: this.mainCat
                    };
                } else {
                    data = {
                        action: 'search_action', 
                        postType: this.postType,
                        searchTerm: this.searchTerm,
                        searchType: 'product',
                    };
                }
                this.ajax(data, this.fetchProductsCallback);
                return;
            },
            fetchCategoriesCallback: function(res) {
                this.categories = res;
                this.isLoading = false;
                this.resetCurrentPageIndex();
                console.log('got categories');
                return;
            },
            fetchSubCategoriesCallback: function(res) {
                this.subCategories = res;
                this.isLoading = false;
                this.resetCurrentPageIndex();
                console.log('got sub-categories');
                return;
            },
            fetchProductsCallback: function(res) {
                this.products = res;
                this.isLoading = false;
                this.resetCurrentPageIndex();
                console.log('got products');
                console.log(res);
                return;
            },
            resetCurrentPageIndex: function() {
                this.currentPageIndex = 0;
            },
            updateCurrentPageIndex: function(index) {
                this.currentPageIndex = index;
            },
            incrementCurrentPageIndex: function() {
                this.currentPageIndex += 1;
            },
            decrementCurrentPageIndex: function() {
                this.currentPageIndex -= 1;
            },
            debounce: function(func, delay) {
                console.log('debounce');
                if(this.debounceTimeout) {
                    clearTimeout(this.debounceTimeout);
                }

                this.debounceTimeout = setTimeout(func, delay);
            }
        }
    });
}
